import { FlexView } from '@cuemath/comps';
import PausePolicy from './pause-hold';
import React from 'react';

const TeacherPauseDetails = () => {
  return (
    <FlexView>
      <PausePolicy />
    </FlexView>
  );
};

export default TeacherPauseDetails;
